import { useState } from "react";
import { useTranslation } from "react-i18next";
import { AppShell } from "../components/layout/AppShell";
import { Users, History } from "lucide-react";
import { UsersPermsTab } from "../features/permissions/UsersPermsTab";
import { AuditLogTab } from "../features/permissions/AuditLogTab";

const TABS = [
  { key: "users", icon: Users },
  { key: "audit", icon: History },
];

export default function PermissionsPage() {
  const { t } = useTranslation();
  const [tab, setTab] = useState("users");

  return (
    <AppShell title={t("perms.pageTitle")} subtitle={t("perms.pageSubtitle")}>
      <div className="grid gap-5">
        <div className="grid grid-cols-2 gap-2" data-testid="perms-tabs">
          {TABS.map(({ key, icon: Icon }) => (
            <button key={key} type="button" data-testid={`perms-tab-${key}`}
                    onClick={() => setTab(key)}
                    className={`flex items-center justify-center gap-2 rounded-2xl px-3 py-3
                                text-xs font-bold transition ${
                      tab === key ? "bg-primary/15 text-primary shadow-neu-in"
                                  : "shadow-neu-sm hover:shadow-neu-md"}`}>
              <Icon className="h-4 w-4" /><span>{t(`perms.tabs.${key}`)}</span>
            </button>
          ))}
        </div>

        {tab === "users" ? <UsersPermsTab /> : <AuditLogTab />}
      </div>
    </AppShell>
  );
}
